<template>
  <va-create-layout>
    <contributors-form :title="title" :item="item"></contributors-form>
  </va-create-layout>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: null,
    },
  },
};
</script>
